/*jQuery animate CPU-FIX*/
jQuery.fx.interval = 50;


var windw = this;
var myWindow;

$( document ).on( "click", "#btn-top", function() {
 	 animateScroll(0);
});

function animateScroll(offset, time, easing) {
  if (typeof time !== 'undefined') {
    var time = parseInt(time, 10);
  } else {
    var time = 1500
  }

  $('html, body').stop().animate({
    scrollTop: offset
  }, time, 'easeInOutExpo');
}

function togglePageTopButton() {

  if ($(window).scrollTop() > 0) {
    $('#btn-top').css('opacity', '1');
  } else {
    $('#btn-top').css('opacity', '0');
  }
  colorPageTopButton();
}

function colorPageTopButton() {

  if (typeof $('#btn-top').offset() == 'undefined'){ /*console.log("btn-top undefined");*/ return;};

  if (typeof $('#footer-main').offset() == 'undefined'){ /*console.log("footer-main undefined");*/ return;};

  /*if ($('#btn-top').offset().top > $('.page-background').outerHeight() - $('#btn-top').outerHeight() && $('#btn-top').offset().top < $('#footer-main').offset().top - $('#btn-top').outerHeight()) {*/
  if ( $('#btn-top').offset().top > $('.page-background').outerHeight() - $('#btn-top').outerHeight() && ( $('#btn-top').offset().top < $('#footer-main').offset().top - $('#btn-top').outerHeight() || $('#btn-top').offset().top > $('.footer-legal-links').offset().top - $('#btn-top').outerHeight() ) ) {
 	$('#btn-top').removeClass('white-scroll-btn').addClass('blue-scroll-btn');
  } else {
	$('#btn-top').removeClass('blue-scroll-btn').addClass('white-scroll-btn');
  }
}

$(document).on('scroll', togglePageTopButton);

/* Quick Order Functions innovate JR 20160812 */

function addField() {
	var inputRow = $("#iwc-hidden-input-row-quick-search div").children( "div.row" ).detach( );

	var $index = parseInt(inputRow.find(".row-number").val()) || 0;
/*	console.log( $index);*/
/*	$index= $index+ 1;*/
	$('form#iwc-quick-order-form').append(inputRow);
	$( document ).trigger( "iwc-quick-order-event-load-new-table-row", $index);
}


function check_matnr(inputField) {
	var $matnr = $(inputField).val();
	var $event = $(inputField).attr("data-check-event");
	$(document ).trigger( $event, $matnr);
}

$(document).ready(function() {
	var newRowTimeout;
	$( document ).on("keydown", ".row:last-child .quantity-input", function(event) {
	if (event.keyCode == 9) {

		if (newRowTimeout) return false;

		newRowTimeout = true;
		addField();
		$(".row:last-child .matnr-input")[0].focus();

		setTimeout( function() {
			newRowTimeout = false;
		}, 100);
		return false;
	}
	});

	$(document).keypress(function(e) {
    		if(e.which == 13) {
        		$("#AddToBasketQuickOrder").click();
    		}
	});

	$("#reset-pw-cancel-form").click(function() {
		document.getElementById("reset-pw-form").reset();
	})
});

/* Quick Order Functions END */

/* Product Comparison innovate JR 20160829 */

var productComparisonWidth = 0;

$(document).ready(function() {
	if ($("#product-comparison-form").length > 0) {
		if ($(".product-comparison-table").width() > 0 ) {
			productComparisonWidth = $(".product-comparison-table").width() + "px";
		} else {
			$(".product-comparison-table").removeClass("fixed-header");
			productComparisonWidth = $(".product-comparison-table").width() + "px";
		}
	}
	createProductComparisonSlider();
});

$(document).scroll(function() {
	if ($("#product-comparison-form").length > 0) {
		createFixedHeaderComparison();
		createFixedSliderComparison();
	}
});

function createFixedSliderComparison() {
	var offset = $(".custom-scrollbar-container").offset().top - window.pageYOffset;
	if (offset < 0) {
		$(".custom-scrollbar-container").addClass("fixed-slider");
	}
	if (window.pageYOffset < 90 && $(".custom-scrollbar-container").hasClass("fixed-slider")) {
		$(".custom-scrollbar-container").removeClass("fixed-slider");
	}
}

function createFixedHeaderComparison() {
	if ($("#product-comparison-form").length > 0) {
		var offset = $("#product-comparison-form .iwc-ui-use-as-link").offset().top - window.pageYOffset;
		var sliderWidth = $(".custom-scrollbar-container").width();

		if (offset < 0) {
			//set table head fixed
			$(".product-comparison-table").addClass("fixed-header");
			$(".product-comparison-table").css("width", productComparisonWidth);
			$(".product-comparison-table tbody").css("width", productComparisonWidth);
			$(".product-comparison-table thead").css("width", productComparisonWidth);
			// set slider fixed
			$(".custom-scrollbar-container").css("position", "fixed");
			$(".custom-scrollbar-container").css("top", "10px");
			//$(".custom-scrollbar-container").css("width", sliderWidth);
			//$(".custom-scrollbar-container").css("width", "100%");
			$("#product-comparison-header-type").attr("value", "fixed-header");

			if (window.pageYOffset < 599) {
				$(".product-comparison-table").removeClass("fixed-header");
				$(".custom-scrollbar-container").css("position", "relative");
				$(".custom-scrollbar-container").css("top", "10px");
				$("#product-comparison-header-type").attr("value", "");
			}
		} else if (window.pageYOffset < 599) {
			$(".product-comparison-table").removeClass("fixed-header");
			$(".custom-scrollbar-container").css("position", "relative");
			$(".custom-scrollbar-container").css("top", "10px");
			$("#product-comparison-header-type").attr("value", "");
		}
		if ($(".custom-scrollbar-container").is(":visible")) {
			moveSlider();
		}
	}
}

function createProductComparisonSlider() {
	if ($(".product-comparison-form").length > 0) {

		$("#product-comparison-form table td").css("float", "none");
		$("#product-comparison-form table").css("width", productComparisonWidth);

		//var maxWidth = parseInt($(".product-comparison-form").css("max-width"));
		var maxWidth = window.innerWidth;

		// + 2 because IE
		if (($("#product-comparison-form table").width() + 2) >= maxWidth) {

			$(".custom-scrollbar-container").css("display", "block");
			$("#product-comparison-form table td").css("float", "none");

			var max = $("#product-comparison-form table").width()  -  $(".product-comparison-form").width();

			if (max > 0) {

				$("#product-comparison-slider").slider({
					max: max,
					slide: moveSlider,
					change: moveSlider
				});
			}
			createFixedHeaderComparison();
		} else {
			$(".custom-scrollbar-container").css("display", "none");
			$("#product-comparison-form table td").css("float", "none");
		}
	}
}

$(window).resize(function() {
	createProductComparisonSlider();
});

function moveSlider() {
	if ($("#product-comparison-slider").slider("value")) {
		var moveLeft = 0 - $("#product-comparison-slider").slider("value");
		$(".product-comparison-table td").css("left", moveLeft);
	} else {
		$(".product-comparison-table td").css("left", 0);
	}
}

$( document ).ready(function(){
	$(document).on("shown.bs.modal", createProductComparisonSlider);
});

function sliderScrollLeft() {

	var value = $("#product-comparison-slider").slider("value");

	if ((value - 10) > $("#product-comparison-slider").slider("option", "min")) {
		value = value - 10;
	} else {
		value = $("#product-comparison-slider").slider("option", "min");
	}

	$("#product-comparison-slider").slider("value", value);
}

function sliderScrollRight() {

	var value = $("#product-comparison-slider").slider("value");

	if ((value + 10) <= $("#product-comparison-slider").slider("option", "max")) {
		value = value + 10;
	} else {
		value = $("#product-comparison-slider").slider("option", "max");
	}

	$("#product-comparison-slider").slider("value", value);
}

function selectProduct(checkbox) {
	var moveLeft = parseFloat($(".product-comparison-table td").css("left"));
	var matnr = $(checkbox).val();

	if (!checkbox.checked) {
		matnr = "";
	}

	$( document ).trigger( "iwc-action-compare", matnr);
	$(".product-comparison-table td").css("left", moveLeft);
}

function closeComparison() {
	if (window.opener != null) {
		window.close();
	} else {
		$("span.icon.winkler-close").click();
	}
}

$(document).on("delete_all_compare_products", function() {
	closeComparison();
	if (window.opener != null) {
		window.opener.refreshSideBarItemsOnList( "compare", 0 );
		window.location.reload();
	} else {
		refreshSideBarItemsOnList( "compare", 0 );
	}
});

function removeAllComparison() {
	$("#product-comparison-remove-all-form").submit();
	closeComparison();
}

function checkForFloat() {

	$("#product-comparison-form table td").css("float", "none");

	$("#product-comparison-form table").css("width", productComparisonWidth);
	if (($("#product-comparison-form table").width() + 2) < window.innerWidth) {
		$(".custom-scrollbar-container").css("display", "none");
		$("#product-comparison-form table td").css("float", "none");
	} else {
		$(".custom-scrollbar-container").css("display", "block");
		$("#product-comparison-form table td").css("float", "none");
	}

	$("#product-comparison-form table").css("width", productComparisonWidth);
}


$(document).on("shown.bs.modal", function() {
	checkForFloat();
});

$(document).on("iwc-comparison-ajax-ready", function() {
	createProductComparisonSlider();
});

function reloadCompareContainer(matCount) {
	$(document).trigger("iwc-action-compare", "");
	refreshSideBarItemsOnList( "compare", matCount );
	$(document).trigger("iwc-action-refresh", "");
}

/* Product Comparison Touch Support */
/* DEAKTIVIERT
var comparisonActiveTouch = false;

$(document).on("touchstart", "#product-comparison-form", function(e) {
	comparisonActiveTouch = true;
	$("html, header").css("overflow-x: hidden;")
	if (e.originalEvent.touches.length > 1) { //more than one touch
		return;
	}
	var xPosStart = e.originalEvent.touches[0].pageX;
	var distance = 0;
	var lastPos = 0;

	if (lastPos == 0) {
		lastPos = xPosStart;
	}

	$(document).on("touchmove", "#product-comparison-form", function(event) {
		var xPosEnd = event.originalEvent.changedTouches[0].pageX;

		distance = lastPos - xPosEnd;

		moveSliderTouch(distance);
		lastPos = xPosEnd;
	});
});

$(document).on("touchend", function(e) {
	if(comparisonActiveTouch) {
		$(document).off("touchmove", "#product-comparison-form");
		comparisonActiveTouch = false;
	}
});

function moveSliderTouch(distance) {
	var moveLeft = parseFloat($(".product-comparison-table td").css("left")) - distance;
	var min = 0;
	var max = 0 - parseFloat($(".product-comparison-table").width()) +  parseFloat($(".product-comparison-form").width());
	if (moveLeft <= max) {
		moveLeft = max;
	} else if (moveLeft >= min) {
		moveLeft = min;
	}
	$(".product-comparison-table td").css("left", moveLeft);
	var handleLeft = (Math.abs(moveLeft) / Math.abs(max)) * 100;
	handleLeft = handleLeft + "%";
	$("#product-comparison-slider .ui-slider-handle").css("left", handleLeft);
}

$(document).ready(function() {
	$(document).on("click", "#product-comparison-form .product-comparison-table .product-image a", function() {
		window.opener.location.href = $(this).attr("href");
		window.close();
	});
	$(document).on("click", "#product-comparison-form .product-comparison-table .iwc-ui-use-as-link", function() {
		window.opener.location.href = $(this).attr("data-link");
		window.close();
	});
	$(document).on("click", "a.comparison-link", function() {
		window.opener.location.href = $(this).attr("href");
		window.close();
	});
});
*/

/* Product Comparison END */

/* Header Mobile */

function changeNavExpandIcon() {
	if ($("#mobile-subheader-dropdown > ul.main-mobile-nav > li.parent > ul").is(":visible")) {
		$(".main-mobile-nav span.nav-item span.icon").attr("class", "icon winkler-expand");
	} else {
		$(".main-mobile-nav span.nav-item span.icon").attr("class", "icon winkler-collapse");
	}
}

$(document).ready(function() {

	//changeNavExpandIcon();

	$("#mobile-subheader-dropdown .tyre-partnershop a").click(function() {
		if ($(".tyre-partnershop-link-wrapper").is(":visible")) {
			$(".tyre-partnershop-link-wrapper").css("display", "none");
		} else {
			$(".tyre-partnershop-link-wrapper").css("display", "block");
		}
	});

	$("#mobile-subheader-dropdown .tyre-partnershop .winkler-close").click(function() {
		$(".tyre-partnershop-link-wrapper").css("display", "none");
	});

	$(".main-mobile-nav span.nav-item").click(function() {
		changeNavExpandIcon();
	});

	$("#mobile-subheader-dropdown > ul.main-mobile-nav > li.parent > span").click(function() {
		if ($("#mobile-subheader-dropdown > ul.main-mobile-nav > li.parent > ul").is(":visible")) {
			$("#mobile-subheader-dropdown > ul.main-mobile-nav > li.parent > ul").hide("fast");
			$(".main-mobile-nav span.nav-item span.icon").attr("class", "icon winkler-expand");
		} else {
			$("#mobile-subheader-dropdown > ul.main-mobile-nav > li.parent > ul").show("fast");
			$(".main-mobile-nav span.nav-item span.icon").attr("class", "icon winkler-collapse");
		}
	});

	$("#toggle-mobile-navigation-btn").click(function() {
		if ($("#mobile-subheader-dropdown").is(":visible")) {
			hideBackgroundOverlay();
		} else {
			showBackgroundOverlay(1000);
		}
	});

	$(window).resize(function() {
		if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ){
			$("#toggle-mobile-navigation-btn").attr("aria-expanded", "false");
			$("#toggle-mobile-navigation-btn").attr("class", "collapsed");

			$("#mobile-subheader-dropdown").attr("aria-expanded", "false");
			$("#mobile-subheader-dropdown").removeClass("in");

			hideBackgroundOverlay();
		}
	});
});

/* Background Overlay */

$(document).ready(function() {
	var overlayDiv = "<div id=\"iwc-background-overlay\"></div>";
	$("body").prepend(overlayDiv);
});

function showBackgroundOverlay(zIndex) {
	$("#iwc-background-overlay").css("display", "block");
	$("#iwc-background-overlay").css("z-index", zIndex);
}

function hideBackgroundOverlay() {
	$("#iwc-background-overlay").css("display", "none");
}

/* Shoppinglist */

	$(document).on("click",".shopping-list-table .shopping-list-checkbox",function() {
		if ($(".shopping-list-table .styled-checkbox-main:checked").length > 1) {
			$(".shopping-list-dashboard .shopping-list-function-btn").removeClass("disabled");
			$(".shopping-list-dashboard .shopping-list-edit").addClass("disabled");
		} else if ($(".shopping-list-table .styled-checkbox-main:checked").length > 0) {
			$(".shopping-list-dashboard .shopping-list-function-btn").removeClass("disabled");
		} else {
			$(".shopping-list-dashboard .shopping-list-function-btn").addClass("disabled");
		}
	});

	$(document).on("click","#shoppinglist-jump-to-new-list", function() {
		$("html, body").animate({ scrollTop: $(".container.shopping-list-forms").offset().top - 20 }, 1000);
	});

	$(document).on("change","#shoppingListUploadCSVButton",function() {
		$("#uploadShoppingListCSVForm").submit();
	});

$(document).on("click", "#iwc-sl-show-all", function() {
	$("#shopping-list-search-form .search-field").val("");
	$("#shopping-list-search-form").submit();
	return false;
});

$(document).on("iwc-event-load-overview", function() {

if (typeof $("#shopping-list-search-form .search-field").val() == "undefined") {
   return false;
}

	if ($("#shopping-list-search-form .search-field").val().length > 0) {
		 $(".shopping-list-dashboard .row.search-information").css("display", "block");
	} else {
		$(".shopping-list-dashboard .row.search-information").css("display", "none");
	}
});

$(document).on("click", "#shopping-list-form .icons-container .add-to-cart-icon.add-to-icons a", function() {
	$(document).trigger("event-add-to-basket");
});


/* EDIT Shoppinglist */

$(document).ready(function() {
	$(shoppingListDetailsListeners());
});

function shoppingListDetailsListeners() {
	$("#shoppinglist-details-article-form .styled-checkbox-main").change(function() {
		checkShoppingListDetailsCheckbox();
	});

	$(document).on("iwc-action-sl-reload-article", function() {
		$(document).trigger("event-add-to-basket");
		$("#shoppinglist-details-article-form").submit();
	});

	$(document).on("iwc-shoppinglist-update-qty", function() {
		$("#shoppinglist-details-article-form").submit();
	});
}

function checkShoppingListDetailsCheckbox() {
	var elements = $("#iwc-shoppinglist-edit-list input[name='information-check[]']");

	if ($("#shoppinglist-details-article-form .styled-checkbox-main:checked").length > 0) {
		$("#shoppinglist-details-article-form .buttons-container .btn").removeClass("disabled");

		if($("#shoppinglist-details-article-form .styled-checkbox-main:checked").length == elements.length) {
			$("#shoppinglist-details-article-form .select-all-items").css("display", "none");
			$("#shoppinglist-details-article-form .deselect-all-items").css("display", "block");
		} else {
			$("#shoppinglist-details-article-form .deselect-all-items").css("display", "none");
			$("#shoppinglist-details-article-form .select-all-items").css("display", "block");
		}
	} else {
		$("#shoppinglist-details-article-form .buttons-container .btn").addClass("disabled");
		$("#shoppinglist-details-article-form .deselect-all-items").css("display", "none");
		$("#shoppinglist-details-article-form .select-all-items").css("display", "block");
	}
}

$(document).on("hidden.bs.modal", function(){
	$(document).trigger("iwc-action-load-overview");
});

function shoppingListEditDisplayEditHead() {
	$("#iwc-shoppinglist-edit-list .overlay-top-information .new-information").css("display", "block");
	$("#iwc-shoppinglist-edit-list .overlay-top-information .save-data-container").css("display", "block");
	$("#iwc-shoppinglist-edit-list .overlay-top-information .edit-data-container").css("display", "none");
	$("#iwc-shoppinglist-edit-list .overlay-top-information .current-information").css("display", "none");
}

function shoppingListEditHideEditHead() {
	$("#iwc-shoppinglist-edit-list .overlay-top-information .new-information").css("display", "none");
	$("#iwc-shoppinglist-edit-list .overlay-top-information .save-data-container").css("display", "none");
	$("#iwc-shoppinglist-edit-list .overlay-top-information .edit-data-container").css("display", "block");
	$("#iwc-shoppinglist-edit-list .overlay-top-information .current-information").css("display", "block");
}

function shoppingListEditScrollToNew() {
	$("html, body").animate({ scrollTop: $("#iwc-shoppinglist-edit-list .shopping-list-detail-edit-product-amount").offset().top - 50 }, 1000);
}

function shoppingListEditCheckAll() {

	var elements = $("#iwc-shoppinglist-edit-list input[name='information-check[]']");

	for (var i = 0; i < elements.length; i++) {
		$(elements[i]).prop("checked", true);
		var name = $(elements[i]).attr("id");
		$("." + name).addClass("winkler-checkbox-checked");
	}
	$("#shoppinglist-details-article-form .select-all-items").css("display", "none");
	$("#shoppinglist-details-article-form .deselect-all-items").css("display", "block");
	checkShoppingListDetailsCheckbox();
}

function shoppingListEditDeselectAll() {

	var elements = $("#iwc-shoppinglist-edit-list input[name='information-check[]']");

	for (var i = 0; i < elements.length; i++) {
		$(elements[i]).prop("checked", false);
		var name = $(elements[i]).attr("id");
		$("." + name).removeClass("winkler-checkbox-checked");
	}
	$("#shoppinglist-details-article-form .select-all-items").css("display", "block");
	$("#shoppinglist-details-article-form .deselect-all-items").css("display", "none");
	checkShoppingListDetailsCheckbox();
}

function submitShoppinglistHeadData(form) {
	var invalid = showIwcValidationMessage(form);
	if(!invalid) {
		$(form).submit();
	} else {
		return false;
	}
}


$(document).on("shown.bs.modal", function() {
	iwc_resize_body($(".modal-content"));
});

$(document).on("hidden.bs.modal",function(){
	iwc_default_body();
});


function iwc_resize_body(iObject){
	if( typeof iObject.offset() == "undefined" ) {return false;}
	var height = iObject.offset().top + iObject.innerHeight() + 180; //180 = margin to the bottom of the page
 	if (height > $("body").height()) {
  		$("body").css("height", height);
 	}
}

function iwc_default_body(){
	$("body").css("height","");
}

function showNewShoppingList() {
	$(".add-to-shopping-list-overlay .shopping-list-information-container").css("display", "block");
	$(".add-to-shopping-list-overlay .new-shopping-list").css("display", "none");
	$(".edit-shopping-list-data .save-data-container").css("display", "block");
	$(".add-to-shopping-list-overlay .confirm-add-to-shopping-list").css("display", "none");
	$(".add-to-shopping-list-overlay .new-information[name='iwc-field-sl-head-name']").attr("required", "required");
	iwc_resize_body($(".modal-content"));
}

function hideNewShoppingList() {
	$(".add-to-shopping-list-overlay .new-shopping-list").css("display", "block");
	$(".add-to-shopping-list-overlay .confirm-add-to-shopping-list").css("display", "block");
	$(".add-to-shopping-list-overlay .shopping-list-information-container").css("display", "none");
	$(".edit-shopping-list-data .save-data-container").css("display", "none");
	iwc_resize_body($(".modal-content"));
}

$(document).on("keydown", "#shoppinglist-details-article-form .shopping-list-detail-edit-product-amount .sl-add-qty-field", function(event) {
	if (event.keyCode == 13) {
		event.preventDefault();
		$("#shoppinglist-details-article-form .shopping-list-detail-edit-product-amount .sl-add-submit-btn").click();
		return false;
	}
});

/*$(document).on("keydown", "#shoppinglist-details-article-form .shopping-list-detail-edit-product-amount .add-product-name-field", function(event) {
	if (event.keyCode == 13) {
		event.preventDefault();
		$("#shoppinglist-details-article-form .shopping-list-detail-edit-product-amount .sl-add-submit-btn").click();
		return false;
	}
});*/


/* Shoppinglist END */

/* Contact Popover */

$(document).on("click", ".service-nav .iwc-contact-popover a.iwc-popover-tooltip", function() {
	if ($(".popover").is(":visible")) {
		$("html, body").animate({ scrollTop: $(".popover").offset().top + $(".popover").height() - screen.availHeight + 100 }, 1000);
	}
});

/* Contact Popover END */

/* Product Request */

$(document).on("product-request-close-dialog-event", function() {
	$(".modal-content .iwc-ui-btn-close").click();
});

$(document).on("contact-close-dialog-event", function() {
	$(".modal-content .winkler-close").click();
});

/* Product Request END */


/* Preference Preview Request */
$(document).on("change", ".iwc-ui-pref-live-preview", function(){
	var ce = $(this);

	var $data = ce.closest("form").serialize();
	var $url = ce.closest("form").find(".iwc-pref-temp-preview-container").attr("data-ajax-url");

      $.ajax({
         type: "POST",
	 data: $data,
         url: $url,
        success: function() {
		var $event = ce.closest("form").find(".iwc-pref-temp-preview-container").attr("data-ajax-event");
		$(document).trigger($event);
         }
       });
});
/* Preference Preview END */

/* Language Selector */

$(document).on("hidden.bs.modal", function() {
	$(".iwc-popover").css("display", "none");
});

/* Language Selector END */





/* Required Products */

function requiredProductsListeners() {
	$("#iwc-required-products-form .styled-checkbox-main").change(function() {
		checkRequiredProductsCheckbox();
	});
}

function checkRequiredProductsCheckbox() {
	if ($("#iwc-required-products-form .styled-checkbox-main:checked").length > 0) {
		$("#iwc-required-products-form .action-buttons .btn.add-to-basket").removeClass("disabled");
	} else {
		$("#iwc-required-products-form .action-buttons .btn.add-to-basket").addClass("disabled");
	}
}

function requiredProductsCheckAll() {
	var elements = $("#iwc-required-products-form input[name='iwc-field-req-check']");

	for (var i = 0; i < elements.length; i++) {
		$(elements[i]).prop("checked", true);
		var name = $(elements[i]).attr("id");
		$("." + name).addClass("winkler-checkbox-checked");
	}
	$("#iwc-required-products-form .iwc-deselect-all").css("display", "block");
	$("#iwc-required-products-form .iwc-select-all").css("display", "none");
	checkRequiredProductsCheckbox();
}

function requiredProductsDeselectAll() {
	var elements = $("#iwc-required-products-form input[name='iwc-field-req-check']");

	for (var i = 0; i < elements.length; i++) {
		$(elements[i]).prop("checked", false);
		var name = $(elements[i]).attr("id");
		$("." + name).removeClass("winkler-checkbox-checked");
	}
	$("#iwc-required-products-form .iwc-deselect-all").css("display", "none");
	$("#iwc-required-products-form .iwc-select-all").css("display", "block");
	checkRequiredProductsCheckbox();
}


   $(document).on("keypress",".add-product-name-field", function(event){
	if (event.keyCode == "13" ){
	    event.preventDefault();
            event.stopPropagation();
	}
    });

    $(document).on("keyup",".add-product-name-field", function(event){
      if( $(this).val() == ""){
        $(this).closest(".row").find(".btn-add").addClass("disabled");
      }else{
        $(this).closest(".row").find(".btn-add").removeClass("disabled");
        if (event.keyCode == "13" ){
            $(this).closest('form').find('input[name=\'__CMS_BUTTON_ID\']').val('iwc-sl-edit-add');
            $(this).closest('form').submit();
	    return false;
        }
      }
    });

$(document).on("keydown", "#iwc-required-products-form", function(event) {
	if (event.keyCode == 13) {
		event.preventDefault();
		return false;
	}
});

/*IWC Form Validation */

function showIwcValidationMessage(form) {
		//console.log("showIwcValidationMessage");
		/* clear */
		form.find( ".iwc-register-invalid-input" ).each(function( ){
			$(this).removeClass( "iwc-register-invalid-input" );
		});
		$(".iwc-register-invalid-message").remove();

		var $parent;

		/* Find all invalid fields within the form. */
		var invalidFields = [];
		form.find("[required]").each(function() {

   			if($(this).val().trim().length == 0) {
				$(this).val("");
			}
		});

		invalidFields = form.find( ":invalid" ).filter( ":visible" );
		invalidFields.each( function( index, node ) {


			/*Set Focus */
			if (index == 0 ){
				$(this).focus();
			}

			/* Hide HTML5 Error Tooltip */

$(this)[0].addEventListener( "invalid",
 function( event ) {

		            event.preventDefault();

			});

			$parent = node.parentNode;
			$($parent).find("input:invalid, select:invalid, textarea:invalid").addClass( "iwc-register-invalid-input" );

			var $fieldMessage = $($parent).find("input:invalid, select:invalid, textarea:invalid").attr("data-field-error-message");
			if ( $fieldMessage == "" || typeof $fieldMessage == "undefined" ){
				/*$fieldMessage = invalidFields[ i ].validationMessage;*/
				$fieldMessage = node.validationMessage;
			}

			var $fieldClass = $($parent).find("input:invalid, select:invalid, textarea:invalid").attr("data-field-error-class");
			if ($fieldClass == ""  || typeof $fieldClass == "undefined" ){
				$fieldClass = "iwc-ui-reg-error-absolut";
			}

			if (window.innerWidth <= 767) {
				$parent.insertAdjacentHTML( "beforeend", "<div class='iwc-register-invalid-message "+ $fieldClass +"'>" +  $fieldMessage + "</div>" );
			} else {
				$parent.insertAdjacentHTML( "beforeend", "<div class='iwc-register-invalid-message "+ $fieldClass +"'>" +  $fieldMessage + "</div>" );
			}
			if (index == 0) {
				$(this).parent().find(".iwc-register-invalid-message").show( );
			}

		});
		if(invalidFields.length > 0) {
			return true;
		} else {
			return false;
		}
	};




var customIwcFormValidation = function() {
	var form = $( this );
	var fakeSubmit = form.find(".iwc-validation-fake-submit");

	var showAllErrorMessages = function() {
		showIwcValidationMessage(form);
	};

	// Support Safari
/*	form.on("submit", function(event) {

		if ( !this.checkValidity() ) {
		if(!event.target.checkValidity()) {
			//$( this ).find( "input.iwc-register-invalid-input" ).first().focus();
			showAllErrorMessages();

			//console.log("preventDefault Submit");
			event.preventDefault();
			event.stopPropagation();
			return false;
			form.submit(false);
		} else {
			console.log("NOT preventDefault Submit");
		}
	});*/

	fakeSubmit.unbind( "click" ).click( function() {
		var isValid = !showIwcValidationMessage( form );
		if (isValid) {
			form.submit();
		}
		return false;
	});

	$( "input[type=submit], button:not([type=button])", form )
		.on( "click", showAllErrorMessages);

	$( "input", form ).on( "keypress", function( event ) {
		var type = $( this ).attr( "type" );
		if ( /date|email|password|month|number|search|tel|text|time|url|week/.test ( type )
		  && event.keyCode == 13 ) {
			showAllErrorMessages();
		}
	});
};

/* init Form-Validation */
$(document).ready(function() {
    $( "form.iwc-validation-form" ).each( customIwcFormValidation );
});

$(document).on("iwc-validation-form-complete",function(){
	setTimeout(function(){
		//console.log("iwc-validation-form-complete");
		$( "form.iwc-validation-form" ).each( customIwcFormValidation );
	}, 1000);
});

$(document).on("focus",".iwc-register-invalid-input", function(){
  if( $(this).is(":invalid") == true){
    $(this).parent().find(".iwc-register-invalid-message").show( );
  }
});

$(document).on("focusout",".iwc-register-invalid-input", function(){
  $(this).parent().find(".iwc-register-invalid-message").hide( );
});

$(document).on("keypress",".iwc-register-invalid-input", function(){
  if( $(this).is(":invalid") == false){
    $(this).parent().find(".iwc-register-invalid-message").hide( );
  }
});

/*!
 * jQuery UI Touch Punch 0.2.3
 *
 * Copyright 2011�2014, Dave Furfero
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Depends:
 *  jquery.ui.widget.js
 *  jquery.ui.mouse.js
 */
!function(a){function f(a,b){if(!(a.originalEvent.touches.length>1)){a.preventDefault();var c=a.originalEvent.changedTouches[0],d=document.createEvent("MouseEvents");d.initMouseEvent(b,!0,!0,window,1,c.screenX,c.screenY,c.clientX,c.clientY,!1,!1,!1,!1,0,null),a.target.dispatchEvent(d)}}if(a.support.touch="ontouchend"in document,a.support.touch){var e,b=a.ui.mouse.prototype,c=b._mouseInit,d=b._mouseDestroy;b._touchStart=function(a){var b=this;!e&&b._mouseCapture(a.originalEvent.changedTouches[0])&&(e=!0,b._touchMoved=!1,f(a,"mouseover"),f(a,"mousemove"),f(a,"mousedown"))},b._touchMove=function(a){e&&(this._touchMoved=!0,f(a,"mousemove"))},b._touchEnd=function(a){e&&(f(a,"mouseup"),f(a,"mouseout"),this._touchMoved||f(a,"click"),e=!1)},b._mouseInit=function(){var b=this;b.element.bind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),c.call(b)},b._mouseDestroy=function(){var b=this;b.element.unbind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),d.call(b)}}}(jQuery);

/* jQuery UI Touch Punch END */


/* Zoom Image  */

$(document).on( "iwc-image-zoom-large-img-not-found", function( event, img ) {
	img.closest(".iwc-ui-image-zoom").parent().find(".zoom-text").css("display","none");
});

/* Bootstrap: Collapse, close all others*/
$(document).on('show.bs.collapse','.iwc-single-collapse.collapse', function() {

    $(document).find('.iwc-single-collapse.collapse.in').collapse('hide');

});

/* Open in Pop-Up */

function openWindowInPopUp(link) {
	try {
		if (MyWindow != "" && !MyWindow.closed) {
			MyWindow.focus();
		} else {
			throw "MyWindow is initial";
		}
	} catch(err) {
		MyWindow = window.open(link, "MyWindow", "scrollbars=yes, width="+screen.width+", height="+screen.height+", resizable=yes");
	}
	return false;
}

/* Open in Pop-Up END */

/* Sidebar */

function refreshSideBarItemsOnList( name, count ){
	var $name = ".items-on-list-" + name;
	var text = "";
	if (count > 99) {
		text = "99+";
	} else {
		text = count;
	}
    	$( $name ).html(text);
    	if( count == 0 || count == "" ){
      		$( $name ).parent( ).hide( );
    	} else {
      		$( $name ).parent( ).show( );
    	}
    	if (name == "compare") {
       		try {
			if (MyWindow != "" && !MyWindow.closed) {
   	       			MyWindow.location.reload();
          			console.log("reload MyWindow");
			}
       		} catch (err) {
       		}
    	}
}

/* Sidebar END */

/* Basket */

$(document).on("keypress", "#iwc-basket-voucher-input",function(e) {
	if (e.keyCode == 13) {
		e.preventDefault();
		$(this).closest("form").submit();
		return false;
	}
});

/* Basket END */

/* togglePriceTab START */

$(document).on("js-event-change-price-tab-withmwst", function(){ togglePriceTab( "withmwst" ); });
$(document).on("js-event-change-price-tab-withoutmwst", function(){ togglePriceTab( "withoutmwst" ); });

function togglePriceTab( $active ){
  var $inActive = "";
  if( $active == "withmwst" ) {
    $inActive = "withoutmwst";
  } else {
    $inActive = "withmwst";
  }
  $(".js-price-box").find("[data-tab-id='"+ $active + "']").parent("li").addClass("active");
  $(".js-price-box").find("[data-tab-id='"+ $inActive + "']").parent("li").removeClass("active");

  $(".js-price-box").find(".tab-content div#" + $active ).addClass("active");
  $(".js-price-box").find(".tab-content div#" + $active ).addClass("in");
  $(".js-price-box").find(".tab-content div#" + $inActive ).removeClass("active");
  $(".js-price-box").find(".tab-content div#" + $inActive ).removeClass("in");
}


/* togglePriceTab End */

/* IOS Background fix */
$(window).on("scroll", function() {
	if (screen.availWidth < 500 && $(".winkler-fullscreen-modal").length > 0) {
		//$(".winkler-fullscreen-modal > .modal-backdrop").css("top", "0px");
		$(".winkler-fullscreen-modal .modal-backdrop.fade.in").addClass("repaint");
	}
});

/* Mobile Elevate Zoom fix */
$(document).ready(function() {
	if ($("#CATALOG").length > 0 && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		setTimeout(function() {
			$("#CATALOG").unbind("touchend");
			$("#CATALOG").unbind("touchmove");
		}, 1000);
	}
});

/* Bestellungen */
$(document).on("click", ".text-center.toggle-information .open-information-message", function() {
	$(".container-fluid.overlay-top-information.order-information").addClass("displayed");
	$(".text-center.toggle-information").removeClass("collapsed");
});

$(document).on("click", ".text-center.toggle-information .close-information-message", function() {
	$(".container-fluid.overlay-top-information.order-information").removeClass("displayed");
	$(".text-center.toggle-information").addClass("collapsed");
});